import { decode } from 'html-entities'
import React from 'react'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import SuspendText from 'srcReact/components/common2/SuspendText'
import Pill from 'srcReact/components/common2/Pill'
import IconButton from 'srcReact/components/common2/IconButton'
import WorkplaceLabel from 'srcReact/components/common2/WorkplaceLabel'
import ReadMore from 'srcReact/components/common2/ReadMore'
import { useDispatch } from 'react-redux'
import { groupHomeActions } from 'srcReact/GroupHomePage'

function Group({ id, g, handleClick, infiniteScrollRef, showUserModal, isSuspended }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleJoinGroup = (e) => {
    e.stopPropagation()
    dispatch(groupHomeActions.addMemberToGroup(g.group_id, `/0/home/group/${g.group_id}`))
  }

  return (
    <div id={id} className={styles.cardItem} onClick={() => handleClick(g)} ref={infiniteScrollRef}>
      <img
        src={g.group_cover ? g.group_cover : require('../../../assets/images/background-default-mixr.jpg')}
        alt={decode(g.group_title)}
        className={`${styles.image} ${g.group_type === 'expertise' && styles.borderedImage}`}
      />

      {g.group_type === 'expertise' && (
        <div className={styles.expertiseGroup}>
          <Icon styleModifier={styles.icon} name='star-solid' size='large24' />
          <div className={`${styles.backgroundImage} ${styles.purple}`} />
        </div>
      )}
      <div className={styles.lable}>
        {g?.workplace && (
          <WorkplaceLabel
            id={g.workplace?.id}
            name={g.workplace?.name}
            color={g.workplace?.color}
            initial={g.workplace?.initials}
          />
        )}
        {g.group_visibility !== 'public' && <Icon name='mask' styleModifier={styles.maskIcon} />}
      </div>
      {isSuspended && (
        <SuspendText
          className={styles.suspendedGroup}
          text={t('moderationReport.suspend.objSuspended', { object: 'group' })}
        />
      )}
      {g.group_common_interests && g.group_common_interests.length >= 1 ? (
        <div className={styles.interests}>
          <Pill shared={true} count={g.group_common_interests.length} className={styles.shared} />
          {g.group_common_interests.slice(0, 2).map((i, idx) => (
            <Pill shared={true} text={i.name} key={idx} className={styles.name} />
          ))}
        </div>
      ) : (
        g.interests &&
        g.interests.length >= 1 && (
          <div className={styles.interests}>
            <Pill shared={true} count={g.interests.length} className={styles.shared} />
            {g.interests.slice(0, 2).map((i, idx) => (
              <Pill text={i.name} key={idx} className={styles.name} />
            ))}
          </div>
        )
      )}

      <div className={styles.titleBlock}>
        <div className={styles.title}>{decode(g.group_title)} </div>
        <IconButton className={styles.arrowRightBtn} iconName='arrow-right' iconSize='large24' />
      </div>
      <div className={styles.description}>
        {/* <div ref={descRef} dangerouslySetInnerHTML={{ __html: g.group_description }} /> */}
        <ReadMore
          showMoreTextWithIcon={t('global.seeMore')}
          showLessTextWithIcon={t('global.seeLess')}
          showMoreButtonCSS={styles.showMoreBtn}>
          {g.group_description}
        </ReadMore>
      </div>
      <div className={styles.cardFooter}>
        <div className={styles.info}>
          <button className={styles.organizerInfo} onClick={(e) => showUserModal(e, g)}>
            <Avatar
              imgWrapperSize={'small43'}
              userId={g.organizer_id}
              profilePicture={g.organizer_picture}
              firstname={g.organizer_firstname}
              lastname={g.organizer_lastname}
              mimeType={g.mime_type}
              originalTag={g.original_tag}
              isOriginal={g.is_original}
              containerCSS={styles.organizerImage}
              onClickAction={(e) => showUserModal(e, g)}
              withExpertiseGroup={g.with_expertise_group}
            />
            {/* <img src={decryptedImage} alt={g.organizer_name} className={styles.image} /> */}
            <div className={styles.nameAndCount}>
              <div className={styles.name}>{g.organizer_name}</div>
              <span className={styles.members}>
                {g.number_of_members} {t('discover.mygroups.members')}
              </span>
            </div>
          </button>
          {g.group_attending === 'pending' ? (
            <div className={`${styles.joinGroupBtn} ${styles.pendingRequestBtn}`}>
              {t('groupHome.header.pendingRequest')}
            </div>
          ) : g.group_visibility !== 'public' ? (
            <button
              type='button'
              className={styles.askToJoinBtn}
              aria-label={t('discover.mygroups.askToJoin')}
              onClick={(e) => handleJoinGroup(e)}>
              <div className={styles.iconStyle}>
                <Icon name='mask' size='large32' styleModifier={styles.maskIconStyle} />
              </div>
              <span>{t('discover.mygroups.askToJoin')}</span>
            </button>
          ) : (
            <button className={styles.joinGroupBtn} type='button' onClick={(e) => handleJoinGroup(e)}>
              {t('discover.mygroups.joinGroup')}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Group
